"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.monitoringConfig").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.monitoring.audit.config", {
            url: "/configuracao",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-monitoring-config" */ "./monitoring-config.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.company.monitoringConfig")
                );
            },
            params: {},
            views: {
                "admin@nucont.accounting": {
                    component: "monitoringConfigComponent",
                    bindings: { companyData: "CompanyData" }
                },
                "monitoringConfigType@nucont.accounting.company.monitoring.audit.config": {
                    component: "monitoringConfigAuditComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            resolve: {
                type: [
                    () => {
                        return "audit";
                    }
                ]
            }
        })

        .state("nucont.accounting.company.monitoring.health.config", {
            url: "/configuracao",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-monitoring-config" */ "./monitoring-config.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.company.monitoringConfig")
                );
            },
            params: {},
            views: {
                "admin@nucont.accounting": {
                    component: "monitoringConfigComponent",
                    bindings: { companyData: "CompanyData" }
                },
                "monitoringConfigType@nucont.accounting.company.monitoring.health.config": {
                    component: "monitoringConfigHealthComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            resolve: {
                type: [
                    () => {
                        return "health";
                    }
                ]
            }
        });
}
